import React, { useState } from "react";
import { Box, Typography } from "@mui/material";
import PropTypes from "prop-types";
import { useNavigate } from "react-router-dom";
import Gestor from "./Gestor";
import Analista from "./Analista";
import Admin from "./Admin";
import profilePicture from "./img/user.png";
import SideBar from "../../components/SideBar/SideBar";

function AdminPanel(props) {
  const [sidebarOpen, setSidebarOpen] = useState(true);
  const permisos = sessionStorage.getItem("rol");
  const userData = JSON.parse(sessionStorage.getItem("userData"));
  for (var clave in userData) {
    if (userData.hasOwnProperty(clave) && typeof userData[clave] === "string") {
      userData[clave] = userData[clave].replace(/^"|"$/g, "");
    }
  }
  const menuItems = [
    "Dashboard",
    "Administrador",
    "Configuración",
    "Ayuda",
    "Salir",
  ];
  return (
    <div>
      <SideBar
        profileImage={profilePicture}
        name={userData.NOMBRE}
        apellido={userData.APELLIDO}
        menuItems={menuItems}
        isOpen={sidebarOpen}
        setIsOpen={setSidebarOpen}
      />
      <Box sx={{ maxWidth: 1200, mx: 'auto', textAlign: 'center', p: 3 }}>
        <Typography variant="h3" fontWeight={700} sx={{ mb: 3 }}>
          Admin Panel
        </Typography>
        {permisos === "1" ? (
          <Gestor />
        ) : permisos === "2" ? (
          <Admin />
        ) : permisos === "4" ? (
          <Analista />
        ) : (
          <div>No tienes permisos</div>
        )}
      </Box>
    </div>
  );
}

AdminPanel.propTypes = {};

export default AdminPanel;
